import React from 'react';
export function UniqueMechanism() {
  return <section className="py-[40px] px-[15px] bg-white border-y border-gray-100" data-id="element-299">
      <div className="container max-w-[800px] mx-auto text-center" data-id="element-300">
        <h2 className="text-[22px] sm:text-[26px] mb-[25px] font-[800] text-[#1A1035] font-['Montserrat']" data-id="element-301">
          🧠 EL SISTEMA DE 7 DÍAS
        </h2>
        <p className="text-[#4B5563] mb-[30px] text-[15px] leading-relaxed max-w-[600px] mx-auto" data-id="element-302">
          Los primeros días tras el diagnóstico o una crisis son los más
          críticos. Esta guía incluye un <strong data-id="element-303">tracker diario</strong> que te
          dice exactamente qué hacer cada día para estabilizar emocionalmente a
          tu familia.
        </p>

        {/* Placeholder for Mechanism Image */}
        <div className="w-full max-w-[600px] mx-auto aspect-[16/9] bg-gradient-to-r from-[#F3E8FF] to-[#E0CFFC] rounded-[12px] flex items-center justify-center border border-[#D8B4FE] shadow-sm relative overflow-hidden" data-id="element-304">
          <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#7C3AED_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-305"></div>
          <div className="text-center p-4 relative z-10" data-id="element-306">
            <div className="text-[#7C3AED] font-bold text-xl mb-2" data-id="element-307">
              PLAN DE ACCIÓN: DÍA 1 A 7
            </div>
            <div className="flex gap-2 justify-center mt-4" data-id="element-308">
              {[1, 2, 3, 4, 5, 6, 7].map(day => <div key={day} className="w-8 h-8 rounded-full bg-white text-[#7C3AED] flex items-center justify-center font-bold text-sm shadow-sm border border-[#A78BFA]" data-id="element-309">
                  {day}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}